import { FootballForm } from '@/features/factory/subfactories/FootballForm'

/** Sub-route /factory/football — Brasileirão top3_standings. */
export function FootballPage() {
  return <FootballForm />
}
